import { render, staticRenderFns } from "./ReservasApp.vue?vue&type=template&id=38038bc4&"
import script from "./ReservasApp.vue?vue&type=script&lang=js&"
export * from "./ReservasApp.vue?vue&type=script&lang=js&"
import style0 from "./ReservasApp.vue?vue&type=style&index=0&id=38038bc4&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports